<template>
  <section class="purchase-page">
    <!-- Banner -->
    <div class="banner-container">
     <img :src="bannerUrl" alt="Banner" class="banner" />
    </div>

    <div class="banner-text"> Shagun Consumer Offer</div>

    <h5 class="terms-title">Terms & Conditions</h5>
    <!-- Container -->
    <div class="container">
      <!-- Card with terms -->
      <div class="card">
        <!-- Loading State -->
        <div v-if="loading" class="state-message">
          Loading terms & conditions...
        </div>

        <!-- Dynamic terms list -->
        <ol v-else-if="terms.length" class="terms-list">
          <li v-for="(term, index) in terms" :key="index">
            {{ term }}
          </li>
        </ol>

        <!-- Empty / Fallback State -->
        <div v-else class="state-message">
          No terms available at the moment.
        </div>

        <label>
          <input
            type="checkbox"
            v-model="agreed"
            :disabled="loading || !terms.length"
          />
          I agree to the T&C
        </label>
        <button
          class="btn btn-primary"
          :disabled="!agreed"
          @click="$emit('validated')"
        >
          Proceed
        </button>

        <div class="otp-footer">
          Powered by Elevatoz PVT LTD
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "axios";


export default {
  name: "TermsCondition",
  setup() {
    const agreed = ref(false);
    const terms = ref([]);
    const loading = ref(true);


    const fetchTerms = async () => {
      try {
        const res = await axios.post(
          "https://loyaltyapi.elevatozrewards.com/vt/centuryCenflex/getTermsCondition",
          {},
          { headers: { "Content-Type": "application/json" } }
        );

        if (res.data?.code === 0 && Array.isArray(res.data?.data?.terms)) {
          terms.value = res.data.data.terms;
        } else if (Array.isArray(res.data?.terms)) {
          terms.value = res.data.terms;
        }
      } catch (error) {
        console.error("Error fetching terms and conditions:", error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      fetchTerms();
    });

    return {
      bannerUrl: process.env.VUE_APP_BANNER_URL,
      agreed,
      terms,
      loading,
    };
  },
};
</script>

<style scoped>
.purchase-page { min-height: 100vh; display: flex; flex-direction: column; background: #f5f5f5; }
.banner img { width: 100%; height: auto; display: block; border-radius: 10px; margin-bottom: 15px; }

.container {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.banner-container {
  max-width: 400px;
  margin: 0 auto 15px auto;
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
}

.banner-container .banner {
  width: 100%;
  display: block;
  border-radius: 10px;
}

.banner-text {
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  color: #000;
  text-align: center;
  margin: 8px auto 15px auto;
  max-width: 90%;
  word-wrap: break-word;
}

.terms-title {
  font-family: 'Inter', sans-serif;
  font-weight: 200;
  font-size: 18px;
  text-align: left;
  margin: 15px 0 10px 0;
  width: 100%;
  max-width: 500px;
  padding: 0 20px;
  box-sizing: border-box;
  color: #000;
}

.state-message {
  text-align: center;
  padding: 15px;
  color: #666;
  font-size: 0.95rem;
}

@media (max-width: 360px) {
  .banner-container {
    max-width: 100%;
    height: 180px;  
  }
  .banner-text {
    font-size: 14px;
    margin: 6px auto 10px auto;
  }
  .terms-title {
    font-size: 16px;
    margin: 4px auto 10px auto;
  }
}

.header { width: 100%; display: flex; flex-direction: column; align-items: center; margin-bottom: 40px; position: relative; }
.header .back-btn { position: absolute; left: 20px; top: 0; background: none; border: none; cursor: pointer; }
.header .title { font-size: 1.3rem; font-weight: 500; margin-bottom: 10px; display: inline; margin-top: -1PX;margin-left: -40px;}
.progress-dots { display: flex; gap: 5px; justify-content: flex-end; width: 100%; margin-top: -27px;}
.progress-dots span { width: 10px; height: 10px; background: #ccc; border-radius: 50%; display: inline-block; }
.progress-dots span.active { background: #006488; }
.card { width: 100%; max-width: 500px; background: #fff; border-radius: 12px; padding: 20px; box-shadow: 0 3px 6px rgba(0,0,0,0.1); box-sizing: border-box; display: flex; flex-direction: column; gap: 15px; }
.terms-list { padding-left: 20px; }
.terms-list li { margin-bottom: 10px; font-size: 0.95rem; color: #333; }

.btn { color: white; background-color: green; width: 100%; padding: 12px; border: none; border-radius: 8px; font-size: 1rem; cursor: pointer; box-sizing: border-box; }
.btn:disabled { background-color: #534747; cursor: not-allowed; color:white }
button:disabled {
  background-color: gray;
  cursor: not-allowed;
}
.otp-footer { align-self: center; margin-top: 10px; font-size: 0.8rem; color: #888; }

@media (max-width: 360px) {
  .purchase-page { padding: 10px; }
  .header .title { font-size: 1.1rem; }
  .card { padding: 15px; }
  .terms-list li { font-size: 0.9rem; }
  .btn { padding: 10px; font-size: 0.95rem; }
}
</style>